export default __webpack_public_path__ + "images/ae51ddb8e56fe402d032762bf0ca4a63-positivity-mindset.svg";